import React, { useState } from "react";
import Aux from "../utils/AuxFunctions";
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import Colors from "../utils/Colors";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";

import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import CongratulationsModal from "../utils/Utilities/CongratulationsModal";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import NotLoggedIn from "../utils/ErrorPages/NotLoggedIn";
import axios from "axios";
import PlusIcon from "mdi-react/PlusIcon";
import MinusIcon from "mdi-react/MinusIcon";
import NumberFormat from 'react-number-format';
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import CheckCircleOutlineIcon from "mdi-react/CheckboxBlankCircleOutlineIcon"
import CheckCircleFilledIcon from "mdi-react/CheckCircleIcon"

import { PayPalButtons } from "@paypal/react-paypal-js";
import LoadingHelper from "../utils/Utilities/LoadingHelper";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";

class AddCoins extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            coins: 0,
            coinsAdded: 0,
            isLoading: false,
            loadingCard: false,
            error: "",
            isSuccess: false,
            loginDialog: false,
            openModal: false,
            paymentMethod: "",
        }
    }

    handleIncrementCoin = (number) => {
        if (this.state.coins === undefined || this.state.coins < 0) {
            this.setState({ coins: number, error:"" })
        } else {
            this.setState(prevState => ({ coins: prevState.coins + number, error:"" }));
        }
    }


    handleDecrementCoin = () => {
        if (this.state.coins === undefined || this.state.coins < 0) {
            this.setState({ coins: 0, error:"" })
        } else {
            this.setState(prevState => ({ coins: prevState.coins - 1, error:"" }));
            //this.slider.setNativeProps({value: this.state.coins -1 });
        }
    }

    handleError = (error) => {
        this.setState({ error: error })
    }

    handleSuccess = (amount) => {
        this.setState({ isSuccess: true, coinsAdded: amount, amount: 0, openModal: true })
    }

    
    goBack = () => {
        try {
            this.props.history.goBack()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    createOrder = (data, actions) => {
        if(!this.state.coins){
            this.setState({error:"Select an amount"})
            return;
        }
        try {
            return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      value: this.state.coins,
                    },
                  },
                ],
              });
        } catch (error) {
            Aux.handleError(error)
            this.setState({error:"An unexpected error has occurred"})
        }
        
    }

    onApprove = async(data, actions) => {
        try{
            let order = await actions.order.capture();
            if(order.status === "COMPLETED"){
                await Fire.shared.addCoinsWithReceipt(this.state.coins, order)
                this.handleSuccess(this.state.coins)

            }else{
                this.setState({error:"An unexpected error has occurred"})
            }
            return order;
        }catch(error){
            Aux.handleError(error)
            this.setState({error:"An unexpected error has occurred"})
        }
    }

    onError = (error) =>{
        Aux.handleError(error)
    }

    render() {
        const isPaypal = this.state.paymentMethod === "paypal"
        const isCredit = this.state.paymentMethod === "credit"
        return (
            <div style={{ width: "100%" }}>
                <section className="container login">
                    <div className="reversed-button-hover" style={{ display: "flex", alignItems: "center", }} onClick={this.goBack}>
                        <ChevronLeftIcon style={{ marginRight: 5 }}></ChevronLeftIcon>
                        <h2>Add coins</h2>
                    </div>
                    <ErrorMessage text={this.state.error}></ErrorMessage>
                    <CongratulationsModal text={"Your payment is complete."} active={this.state.openModal} onClose={() => this.setState({openModal: false})} coins={this.state.coinsAdded}></CongratulationsModal>
                    <SucessMessage isSucess={this.state.isSuccess} text={"You've successfully added " + this.state.coinsAdded + "$ to your balance"}></SucessMessage>
                    <NotLoggedIn active={this.state.loginDialog} onClose={() => this.setState({ loginDialog: false })}></NotLoggedIn>
                    {this.props.myDataProvider.user ?
                        <div>
                            <div style={{ marginTop: 20 }}>
                                <div >
                                    <span style={{ display: "flex", alignSelf: "flex-start", margin: "20px 0", color: "#ccc", fontWeight: "bold" }} >Enter Amount</span>
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", margin: "5px 20px", alignItems:"center" }}>

                                        <div onClick={this.handleDecrementCoin} style={{marginLeft:15}}>
                                            <MinusIcon className="coins-icon" ></MinusIcon>
                                        </div>
                                        <div>
                                            <NumberFormat placeholder="0,00" className="add-coins-input" value={this.state.coins} thousandSeparator={true} prefix={'$'} allowNegative={false} decimalScale={0}
                                                onValueChange={(values) => {
                                                    const { floatValue } = values;
                                                    this.setState({ coins: floatValue, error:"" })
                                                }} />
                                            {/* <input className="add-coins-input" value={this.state.coins} type="number" min="0" step="1" pattern="[0-9]*"></input> */}
                                        </div>
                                        {/* <h3>${this.state.coins}</h3> */}
                                        <div onClick={() => this.handleIncrementCoin(1)} style={{marginRight:15}}>
                                            <PlusIcon className="coins-icon" ></PlusIcon>
                                        </div>

                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap:"wrap" }}>
                                    <span className="coins-add-value" onClick={() => this.handleIncrementCoin(5)}>+5$</span>
                                    <span className="coins-add-value" onClick={() => this.handleIncrementCoin(25)}>+25$</span>
                                    <span className="coins-add-value" onClick={() => this.handleIncrementCoin(100)}>+100$</span>
                                    <span className="coins-add-value" onClick={() => this.handleIncrementCoin(500)}>+500$</span>
                                </div>
                            </div>
                            
                            <div style={{marginTop:30}}>
                                <span style={{ color: "#ccc", fontWeight: "bold" }}>Payment Method</span>
                                <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                    <ButtonLoader
                                        text="Credit Card"
                                        icon={isCredit ? CheckCircleFilledIcon : CheckCircleOutlineIcon}
                                        style={{ backgroundColor: isCredit ? Colors.mainColor : "#efefef", color: isCredit ? "white" : Colors.middleText, marginTop: 20, }}
                                        onClick={() => this.setState({paymentMethod: this.state.paymentMethod === "credit" ? "" : "credit", error:""})}
                                    />
                                    <ButtonLoader
                                        text="Paypal"
                                        icon={isPaypal ? CheckCircleFilledIcon : CheckCircleOutlineIcon}
                                        style={{ backgroundColor: isPaypal? Colors.mainColor : "#efefef", color: isPaypal ? "white" : Colors.middleText, marginTop: 20, marginLeft: 30 }}
                                        onClick={() => this.setState({paymentMethod: this.state.paymentMethod === "paypal" ? "" : "paypal", error:""})}
                                    />
                                </div>
                            </div>  
                            
                            {isCredit ?
                            <div>                    
                                <CheckoutForm amount={this.state.coins} email={this.props.myDataProvider.user?.email || ""} onError={this.handleError} onSuccess={this.handleSuccess}></CheckoutForm>
                            </div>
                            : isPaypal ?
                                <div style={{margin:"20px 0"}}>
                                    <span style={{ color: "#ccc", fontWeight: "bold" }}>Pay with Paypal</span>
                                    
                                    {this.state.coins > 0 ?
                                    <div>
                                        <div style={{ display: "flex", justifyContent:"center", margin: "20px 0" }}>
                                            <span style={{ color: Colors.softText }}>Price: </span>
                                            <span style={{ color: Colors.mainColor, marginLeft: 5, fontWeight: "bold" }}> {this.state.coins || 0}.00$</span>
                                        </div>
                                        <PayPalButtons  
                                            style={{ layout: "horizontal" }}
                                            createOrder={(data, actions) => this.createOrder(data, actions)}
                                            onApprove={(data, actions) => this.onApprove(data, actions)}
                                            onCancel={() =>Aux.handleError("Canceled")}
                                            onError={(err) => this.onError(err)}
                                        ></PayPalButtons>
                                    </div> : 
                                    <div>
                                        <div style={{ display: "flex", justifyContent:"center", margin: "20px 0" }}>
                                            <span style={{ color: Colors.softText }}>Add an amount first. </span>
                                        </div>
                                        <ButtonLoader
                                            text="PayPal"
                                            disabled={true}
                                            style={{ backgroundColor: Colors.softText, padding: "12px 20px", width: "100%", marginTop: 10 }}
                                        />
                                    </div>}  
                                </div>                   
                            : null}
                            </div>
                        : <LoadingHelper></LoadingHelper>}
                </section>
            </div>
        );
    }
}

export default withMyDataContext(AddCoins);

function CheckoutForm({ amount, email, onError, onSuccess }) {
    const [isLoading, setLoading] = useState(false)
    const [isCardComplete, setCardComplete] = useState(false)
    const [holderName, setHolderName] = useState("")
    const [addCard, setAddCard] = useState(false)
    /* const [name, setName] = useState();
    const [myEmail, setEmail] = useState(email) */
    const stripe = useStripe();
    const elements = useElements();
    const cardOptions = {
        style: {
            base: {
                color: "#32325d",
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#aab7c4",
                },
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a",
            },
        },
        hidePostalCode: true,
        disabled: isLoading,
    };


    const handleSubmit = async () => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        //event.preventDefault();

        if (!stripe || !elements ) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        if (!amount || amount <= 0) {
            onError("Enter an amount first")
            return
        }

        if (!email) {
            onError("Add your email to your profile")
            return
        }

        if(!holderName){
            onError("Add a name")
            return
        }
        try {
            setLoading(true)
            const { data: clientSecret } = await axios.post(process.env.REACT_APP_API_URL_PAY_STRIPE, { email: email, amount: amount * 100 })
            //console.log(response.json())
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                    billing_details: {
                        email: email,
                        name: holderName,
                    },
                }
            });

            if (result.error) {
                // Show error to your customer (e.g., insufficient funds)
                onError(result.error.message)
                setLoading(false)
            } else {
                // The payment has been processed!
                console.log(result)
                if (result.paymentIntent.status === 'succeeded') {
                    await Fire.shared.addCoinsWithReceipt(amount, result.paymentIntent)
                    setAddCard(false)
                    onSuccess(amount)
                    setHolderName("")
                    setLoading(false)
                    // Show a success message to your customer
                    // There's a risk of the customer closing the window before callback
                    // execution. Set up a webhook or plugin to listen for the
                    // payment_intent.succeeded event that handles any business critical
                    // post-payment actions.
                }
            }
        } catch (error) {
            Aux.handleError(error)
            onError("an unexpect error has occurred")
            setLoading(false)
        }
    };
    const disabled = amount > 0 ? isCardComplete ? holderName !== "" ? false : true : true : true

    return (
        <div style={{ marginTop: 20 }}>
            <div style={{marginTop:20}}>
                <span style={{ color: "#ccc", fontWeight: "bold" }}>Choose Card</span>
                {!addCard ?
                    <div className="button-hover"
                        style={{
                            display: "flex", width: "100%", padding: "30px 0px", marginTop: 20,
                            justifyContent: "center", alignItems: "center", borderRadius: 10, backgroundColor: `rgba(0, 145, 234, 0.1)`,
                        }}
                        onClick={() => setAddCard(true)}>
                        <span style={{ color: Colors.mainColor }} > {"+ Add a card"}</span>
                    </div>
                    :
                    <div>
                        <div style={{ marginTop: 20, padding: 20, }}>
                            <div style={{ backgroundColor: "#f9f9f9", padding: "15px 20px" }}>
                                <div style={{marginBottom:5}}>
                                    <span>Name</span>
                                </div>
                                <TextInputMaterial maxLength={30} type="text" placeholder="Card holder name"
                                    onChange={(e) => {setHolderName(e.target.value)}}
                                />
                            </div>
                            <div style={{ backgroundColor: "#f9f9f9", padding: 20, marginTop:15 }}>
                                <div style={{marginBottom:10}}>
                                    <span>Card Information</span>
                                </div>
                                 <CardElement options={cardOptions} onChange={(cardDetails) => {
                                    if (cardDetails.complete) {
                                        setCardComplete(true)
                                    } else if (cardDetails.error) {
                                        onError(cardDetails.error.message)
                                    } else {
                                        setCardComplete(false)
                                    }

                                }}/>
                            </div>
                            {/* <div style={{ display: "flex", justifyContent: "start", marginTop: 30 }}>
                                <ButtonLoader text="add Card" style={{ backgroundColor: isCardComplete ? Colors.mainColor : Colors.softText, padding: "10px 30px" }}
                                    disable={!isCardComplete} onClick={() => setShowCard(true)}>
                                </ButtonLoader>
                            </div> */}
                        </div>

                    </div>
                }
            </div>
           {/*  <div style={{borderBottom: "1px solid #ccc", margin:"auto", marginTop:20, width:"70%", }}></div> */}
            <div style={{ marginTop: 20, display: "flex", flexDirection: "column", alignItems: "center" }}>
                
                <div style={{ display: "flex", marginBottom: 10 }}>
                    <span style={{ color: Colors.softText }}>Price: </span>
                    <span style={{ color: Colors.mainColor, marginLeft: 5, fontWeight: "bold" }}> {amount || 0}.00$</span>
                </div>
                <ButtonLoader text={"Pay " + amount + ".00$"} onClick={handleSubmit} loading={isLoading} disabled={disabled} style={{ backgroundColor: disabled ? Colors.softText : "" }}>

                </ButtonLoader>
            </div>
        </div>
    );
}